import React, { useEffect } from 'react'
import "./common.scss"
import loginsideBanner from "../assets/images/LoginSideBanner.png"
import CrossIcon from '../assets/icons/CrossIcon'
import { useState } from 'react'
import { _Apiauth } from '../../common/api'
import { useTranslation } from "react-i18next";
const Login = (props) => {
    const { setOpenmodal, setEmailVerifydata } = props
    const { t } = useTranslation()
    const [logindata, setLogindata] = useState()
    const [validation, setValidation] = useState()
    const [lodaer, setLodaer] = useState(false)
    const alllogindata = (keyName, value) => {
        setLogindata((prevState) => ({
            ...prevState,
            [keyName]: value,
        }))
    }
    // eslint-disable-next-line
    const ecomlogin = async () => {
        const validfrom = () => {
            let fromisvalid = true
            if (!logindata?.email) {
                setValidation(prevState => ({
                    ...prevState,
                    emailvalid: {
                        message: "Email is required",
                        status: true
                    }
                }));
                fromisvalid = false
            } else {
                const isEmail = (email) =>
                    /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i.test(email);
                if (!isEmail(logindata?.email)) {
                    setValidation(prevState => ({
                        ...prevState,
                        emailvalid: {
                            message: "Invalid Email",
                            status: true
                        }
                    }));
                    fromisvalid = false
                } else {
                    setValidation(prevState => ({
                        ...prevState,
                        emailvalid: {
                            message: "",
                            status: false
                        }
                    }));
                }
            }
            if (!logindata?.password) {
                setValidation(prevState => ({
                    ...prevState,
                    passwordvalid: {
                        message: "Password is required",
                        status: true
                    }
                }));
                fromisvalid = false
            } else {
                setValidation(prevState => ({
                    ...prevState,
                    passwordvalid: {
                        message: "",
                        status: false
                    }
                }));
            }
            return fromisvalid;
        }
        if (validfrom()) {
            setLodaer(true)
            try {
                const postdata = logindata
                var res = await _Apiauth(postdata, `auth/login`)
                if (res?.statusCode === 200) {
                    if (res?.isVarified === 1) {
                        setEmailVerifydata({ accessToken: res?.accessToken, email: logindata?.email })
                        setOpenmodal(prevState => ({
                            ...prevState,
                            showLoginModel: false,
                            showRegisterModel: false,
                            showemailvarifymodal: true,
                            forgetpassword: false,
                            resetpassword: false,
                            newpassword: false
                        }))
                    } else {
                        localStorage.setItem('ecomaccesstoken', (res?.accessToken));
                        setOpenmodal(prevState => ({
                            ...prevState,
                            showLoginModel: false,
                            showRegisterModel: false,
                            showemailvarifymodal: false,
                            forgetpassword: false,
                            resetpassword: false,
                            newpassword: false
                        }));
                    }
                    setLodaer(false)
                } else {
                    setValidation(prevState => ({
                        ...prevState,
                        sussess: {
                            message: res?.message,
                            status: true
                        }
                    }));
                    setLodaer(false)
                }
            }
            catch (err) {
                setLodaer(false)
                console.log(err, "err")
                if (err?.response?.status) {
                    setValidation(prevState => ({
                        ...prevState,
                        sussess: {
                            message: err.response.data.message,
                            status: true
                        }
                    }));
                }

            }
        }
    }
    useEffect(() => {
        const handleKeyPress = (event) => {
            if (event.key === 'Enter') {
                ecomlogin();
            }
        };
        document.addEventListener('keypress', handleKeyPress);
        return () => {
            document.removeEventListener('keypress', handleKeyPress);
        };
        // eslint-disable-next-line
    }, [ecomlogin]);
    return (
        <div className='ecommerce-login-overlay'>
            <div className='ecommerce-login'>
                <span className='Cross_icon' onClick={() => {
                    setOpenmodal(prevState => ({
                        ...prevState,
                        showLoginModel: false,
                        showRegisterModel: false,
                        showemailvarifymodal: false,
                        forgetpassword: false,
                        resetpassword: false,
                        newpassword: false
                    }));
                }} >
                    <CrossIcon width={30} height={30} />
                </span>
                <div className='ecommerce-login-inner'>
                    <div className='ecommerce-login-inner-title'>
                        <div className='ecommerce-login-inner-title-heading text-center'>{t("WELCOME BACK")}</div>
                        <div className='ecommerce-login-inner-title-sub-title text-center'> {t("If you have an account with us, please log in")}. </div>
                    </div >
                    <div className='ecommerce-login-inner-input_section'>
                        <div className={`ecommerce-login-inner-input_section-inner ${validation?.emailvalid?.status && "required"}`}>
                            <label>
                                {t("Email")}
                            </label>
                            <input className={`ecommerce-login-inner-input_section-inner-input ${validation?.emailvalid?.status && "border-danger"}`}
                                onChange={(e) => alllogindata("email", e.target.value)} />
                            {validation?.emailvalid?.status ?
                                <div className='text-danger'>
                                    {t(`${validation?.emailvalid?.message}`)}
                                </div>
                                : ""}
                        </div>
                        <div className={`ecommerce-login-inner-input_section-inner ${validation?.passwordvalid?.status && "required"}`}>
                            <label>
                                {t("Password")}
                            </label>
                            <input className={`ecommerce-login-inner-input_section-inner-input ${validation?.passwordvalid?.status && "border-danger"}`}
                                type='password'
                                onChange={(e) => alllogindata("password", e.target.value)}
                            />
                            {validation?.passwordvalid?.status ?
                                <div className='text-danger'>
                                    {t(`${validation?.passwordvalid?.message}`)}
                                </div>
                                : ""}
                            <div className='ecommerce-login-inner-input_section-inner-forget_password'
                                onClick={() => setOpenmodal(prevState => ({
                                    ...prevState,
                                    showLoginModel: false,
                                    showRegisterModel: false,
                                    showemailvarifymodal: false,
                                    forgetpassword: true,
                                    resetpassword: false,
                                    newpassword: false
                                }))}>
                                {t("Forgot Password")}?
                            </div>
                        </div>
                        {validation?.sussess?.status ?
                            <div className='text-danger'>{t(validation?.sussess?.message)}</div> : ""
                        }
                        {lodaer ? <button className='ecommerce-login-inner-input_section-btn'>
                            <div className="border-bottom-0 border-width-2px text-white d-block mx-auto spinner-border flex-shrink-0" role="status"></div>
                        </button> :
                            <button className='ecommerce-login-inner-input_section-btn' onClick={() => ecomlogin()}>
                                {t("SIGN IN")}
                            </button>}

                    </div>
                    <div className='ecommerce-login-inner-create-account'>
                        <div className='ecommerce-login-inner-create-account-register_btn'>
                            {t("Don’t have an account")}?
                            <span onClick={() => {
                                setOpenmodal(prevState => ({
                                    ...prevState,
                                    showLoginModel: false,
                                    showRegisterModel: true,
                                    showemailvarifymodal: false,
                                    forgetpassword: false,
                                    resetpassword: false,
                                    newpassword: false
                                }));
                            }}>
                                {t("SIGN UP")}
                            </span>
                        </div>
                        <div className='ecommerce-login-inner-create-account-privacy_notice'>
                            {t("By continuing, I confirm that I have read and agree to the")}
                        </div>
                        <div className='ecommerce-login-inner-create-account-privacy_notice no_padding'>
                           {t("Privacy Notice")} {t("and Term and Conditions")}
                        </div>
                    </div>
                </div >
                <div className='ecommerce-login-sidebanner'>

                    <img src={loginsideBanner} alt='side_banner' />
                </div >
            </div >
        </div >
    )
}

export default Login